// extracted by mini-css-extract-plugin
export var chevron = "_2e-2";
export var chevronCollapsed = "_2e-3";
export var collapsibleHeader = "_2e-1";
export var container = "_2e-0";